import { Popover, styled } from "@mui/material"

import { L2RMenu } from "../L2RMenu"

const MENU_MAX_WIDTH = 310

export const Menu = styled(L2RMenu)(() => ({
    "& .MuiMenu-paper": {
        maxWidth: MENU_MAX_WIDTH,
    },
}))

export const ContainerPopover = styled(Popover)(({ theme }) => ({
    direction: "rtl",
    pointerEvents: "auto",

    ".MuiPopover-paper": {
        borderRadius: theme.spacing(3),
    },
}))
